import { useContext, useEffect, useState } from "react"

import { Card, Col, Row, Typography } from "antd"
import { createSearchParams, useNavigate } from "react-router-dom"

import { SvgImage } from "@/components/_Shared/SvgImage/SvgImage"
import { CustomerContext } from "@/context/CustomerContext"

import classes from "./Balance.module.scss"

import { useCustomerByIdQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"

import { paths } from "@/router/paths"

import { getMoney } from "@/utils/formatNumber"


const { Title } = Typography

export type BalanceProps = {}

export const Balance = (props: BalanceProps) => {
  const userContext = useContext(CustomerContext)
  const { data: customer } = useCustomerByIdQuery(userContext?.customer?.id ?? 0)
  const navigate = useNavigate()

  const [balanceSum, setBalanceSum] = useState<number>(0)
  const [sumOrderSum, setSumOrderSum] = useState<number>(0)
  const [paidOrderSum, setPaidOrderSum] = useState<number>(0)
  const [availableSum, setAvailableSum] = useState<number>(0)

  const onClickOrderedBalance = () => navigate({
    pathname: paths.ordersHistory,
    search: createSearchParams({
      active: "true"
    }).toString()
  })

  const onClickBalanceOrAvailable = () => navigate(paths.customerFinance)

  useEffect(() => {
      setBalanceSum(customer?.response.balance ?? 0)
      setSumOrderSum(customer?.response.sumOrder ?? 0)
      setPaidOrderSum(customer?.response.paidOrderSum ?? 0)
      setAvailableSum(customer?.response.availableSum ?? 0)
  }, [customer])

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(balanceSum)}
              <h5>&nbsp;</h5>
            </Title>
            <h5>Баланс</h5>
            <SvgImage src="wallet-icon.svg" height={68} width={68} className={ `${classes.balanceIconSvg} ${classes.wallet}` }/>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickOrderedBalance}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(sumOrderSum)}
              <h5>оплачено {getMoney(paidOrderSum)}</h5>
            </Title>
            <h5>Сумма заказов в работе</h5>
            <SvgImage src="cyrcle-icon.svg" height={72} width={72} className={ `${classes.balanceIconSvg} ${classes.cyrcle}` }/>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>
              {getMoney(availableSum)}
              <h5>&nbsp;</h5>
            </Title>
            <h5>Сумма доступная для заказа</h5>
            <SvgImage src="check-icon.svg" height={65} width={65} className={ `${classes.balanceIconSvg} ${classes.check}` }/>
          </Card>
        </Col>
      </Row>
    </>
  )
}